<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import StockList from "@/components/tables/stock-list.vue";
import CreateStockRequestModal from "@/components/modals/create-stock-request-modal.vue";

export default {
    page: {
        title: "Stocks"
    },
    components: {
        Layout,
        PageHeader,
        StockList,
        CreateStockRequestModal
    },
    data() {
        return {
            title: "Stocks",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/"
                },
                {
                    text: "Stocks",
                    active: true
                }
            ],
            tabIndex: 0,
            loading: false,
            stockList: []
        };
    },
    methods: {
        async changeCampus(campus) {
            this.loading = true;
            await this.getStockList(campus.id);
            this.loading = false;
        },
        async getStockList(campusId) {
            this.loading = true;
            try {
                const { data: response } = await this.$store.dispatch("stock/GetStockListAvailable", campusId);
                if (response?.error) {
                    this.showToast(response?.errorMessage || "Failed to load stock list.", "error");
                    return;
                }
                this.stockList = Array.isArray(response) ? response : (response?.data || []);
            } catch (error) {
                this.showToast(error?.message || "Something went wrong loading stock list.", "error");
            } finally {
                this.loading = false;
            }
        },
        openCreateRequestModal(selectedStocks) {
            if (this.$refs.createRequestModal) {
                this.$refs.createRequestModal.open(selectedStocks);
            }
        },
        async onCreateRequest(payload) {
            try {
                payload.campusId = this.$store.state.data.selectedCampus.id;
                payload.deliveryUnitId = this.$store.state.data.selectedDU.id;

                const res = await this.$store.dispatch("requisition/CreateRequisition", payload);
                if (res?.data?.error) {
                    this.showToast(res.data.errorMessage || "Failed to create requisition.", "error");
                    return;
                }
                this.showToast("Successfully created stock request!", "success");
                if (this.$refs.createRequestModal) {
                    this.$refs.createRequestModal.hide();
                }
                await this.getStockList(this.$store.state.data.selectedCampus.id);
            } catch (error) {
                this.showToast(error?.message || "Something went wrong creating requisition!", "error");
            }
        }
    },
    async created() {
        this.loading = true;
        if (this.$store.state.data.selectedCampus && this.$store.state.data.selectedCampus.id) {
            await this.getStockList(this.$store.state.data.selectedCampus.id);
        }
        this.loading = false;
    }
};
</script>

<template>
    <Layout @changeCampus="changeCampus">
        <PageHeader :title="title" :items="items" />
        <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="mdi mdi-view-list-outline"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Stock List</span>
                </template>
                <StockList
                    :stockList="stockList"
                    :loading="loading"
                    @create-request="openCreateRequestModal"
                />
            </b-tab>
            <b-tab>
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="mdi mdi-view-list-outline"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Pending Request</span>
                </template>
            </b-tab>
        </b-tabs>

        <!-- Create Stock Request Modal -->
        <CreateStockRequestModal
            ref="createRequestModal"
            @submit="onCreateRequest"
        />
    </Layout>
</template>